"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _TextField = _interopRequireDefault(require("../TextField"));

var _excluded = ["classes", "options", "value"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SelectIcon = function SelectIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "10",
    viewBox: "0 0 16 10"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#CECECE",
    fillRule: "nonzero",
    d: "M11.701 5.315L7.927 9.089 4.153 5.315.378 1.54l.37-.37.368-.369 3.411 3.411 3.411 3.411 3.405-3.405L14.748.812l.364.364.364.364L11.7 5.315z"
  }));
};

var styles = function styles(theme) {
  return {
    selectIcon: {
      top: "calc(50% - 5px)"
    }
  };
};

function Select(_ref) {
  var classes = _ref.classes,
      options = _ref.options,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_TextField["default"], _extends({
    select: true,
    SelectProps: {
      classes: {
        icon: classes.selectIcon
      },
      IconComponent: SelectIcon
    },
    fullWidth: true,
    value: value
  }, rest), options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      key: option.value,
      value: option.value
    }, option.label);
  }));
}

Select.propTypes = {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
    label: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  })),
  value: _propTypes["default"].string
};
Select.defaultProps = {
  options: [],
  value: ""
};

var _default = (0, _styles.withStyles)(styles)(Select);

exports["default"] = _default;